<app-filter-header title="Filtrar Respuestas" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-text-edit id="respostes-filter-codi" class="col-sm-2" i18n-label label="Cód. Respuesta" [(value)]="this.filter.codi" ></app-form-text-edit>
    <app-form-text-edit id="respostes-filter-descripcio" class="col-sm-8" i18n-label label="Descripción" [(value)]="this.filter.descripcio" ></app-form-text-edit>
    <app-form-check-edit id="respostes-filter-acceptacio" class="col-sm-2" i18n-label label="Aceptación" [(value)]="this.filter.acceptacio" ></app-form-check-edit>

  </div>
</div>
